const versionNumber =
    import.meta.env.VITE_ENV_TYPE === "production"
        ? (import.meta.env.VERSION ?? "production")
        : (import.meta.env.VITE_ENV_TYPE as string);

// Format version number consistent with the one in Profile.tsx
const formattedVersion = versionNumber.startsWith("v") ? `v${versionNumber.substring(3)}` : versionNumber;
const userAgentSuffix = `expert-workspace/${formattedVersion}`;

export function buildChatJSGlobalConfig(region: string) {
    return {
        region,
        customUserAgentSuffix: userAgentSuffix,
    };
}
